import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"
import { navigate } from "gatsby"

const HIDDEN_PATHS = ["/contact/", "/contact/thanks/"]

export const onRouteUpdate = ({ location }) => {
  if (HIDDEN_PATHS.includes(location.pathname)) {
    navigate("/", { replace: true })
  }
}
